// mediaTagging/tagInputPosition.js — pure geometry for placing the tag `.input` panel.
//
// Extracted from TagBoxJQueryAdapter.repositionInput (plan mediatagging_topo2_fusion, phase
// tag-view-extraction, Schritt 3-A). The adapter still measures the DOM and applies the result;
// only the decision math lives here, as pure functions, so it can be unit-tested without a layout
// engine. Behavior-preserving: the arithmetic (including the edge quirks) mirrors the original.

// The css `left` that horizontally centers the input over its tag box.
// Returns currentLeft unchanged when the two are already centered.
export function centeredInputLeft(currentLeft, inputRect, tagBoxRect) {
    const inputCenter  = inputRect.x + inputRect.width / 2;
    const tagBoxCenter = tagBoxRect.x + tagBoxRect.width / 2;
    return inputCenter !== tagBoxCenter ? currentLeft - inputCenter + tagBoxCenter : currentLeft;
}

// Keeps the (already centered) input panel inside the viewport and drops it below the box.
// Returns the css to apply: { left?, top? }. An empty object means "leave as is".
// NOTE: the right-overflow `else` term (currentLeft - inputRight - viewportWidth) is preserved
// verbatim from the legacy code — it looks suspicious but is kept behavior-identical on purpose.
export function clampInputToViewport({ viewportLeft, currentLeft, inputRight, inputWidth, viewportWidth, tagBoxHeight }) {
    const belowBox = tagBoxHeight + 1;

    if (viewportLeft <= 1) {
        // Past (or at) the left edge: push right so the viewport-left becomes 1.
        if (viewportLeft !== 1) {
            return { left: -viewportLeft + currentLeft + 1, top: belowBox };
        }
        return {};   // exactly 1 → the legacy code applied nothing (not even top)
    }

    if (inputRight > viewportWidth || currentLeft + inputWidth > viewportWidth) {
        // Past the right edge: pull left by the overshoot.
        const overshoot = inputRight > viewportWidth
            ? inputRight - viewportWidth
            : currentLeft - inputRight - viewportWidth;
        return { left: currentLeft - overshoot, top: belowBox };
    }

    return { top: belowBox };   // fits: only drop below the box
}
